/**
 * Projects are editable in the left panel but hidden from live preview until layout is finalized.
 */
export const PROJECTS_SECTION_IN_PREVIEW = false
